import { defineComponent, computed, ref } from '@vue/composition-api';
import Teleport from 'vue2-teleport';
import MainVue from './components/main.vue';
import Photos from './components/photos.vue';
import useStore from './store';
import MyBottom from './components/bottom.vue';
import Gift from './components/gift.vue';
import PostPopup from './sub-components/post-popup.vue';
import MyPost from './sub-components/post.vue';
export default defineComponent({
  components: {
    MainVue: MainVue,
    Photos: Photos,
    MyBottom: MyBottom,
    Gift: Gift,
    PostPopup: PostPopup,
    MyPost: MyPost,
    Teleport: Teleport
  },
  setup: function setup(props, ctx) {
    var store = useStore();
    var photoList = computed(function () {
      // 未开放的不透出
      if (store.activeVenueOpen) {
        var _store$activeVenue;

        return ((_store$activeVenue = store.activeVenue) === null || _store$activeVenue === void 0 ? void 0 : _store$activeVenue.feeds) || [];
      }

      return [];
    });
    var finalRef = ref(null);
    var postRef = ref(null);

    var handleToPost = function handleToPost() {
      if (postRef.value) {
        postRef.value.toPost();
      }
    };

    var getOrigin = function getOrigin(url) {
      try {
        return new URL(url).origin;
      } catch (e) {
        return '';
      }
    };

    var isChina = function isChina(str) {
      var pattern = new RegExp("[\u4E00-\u9FA5]+");
      return pattern.test(str);
    };

    var formatName = function formatName(name) {
      var length = 0;
      var sliceEnd = 0;

      for (var i = 0; i < name.length; i++) {
        if (isChina(name[i])) {
          length += 2;
        } else {
          length += 1;
        }

        if (length > 11) {
          sliceEnd = i;
          break;
        }
      }

      if (length > 11) {
        return "".concat(name.slice(0, sliceEnd), "...");
      }

      return name;
    };

    return {
      store: store,
      photoList: photoList,
      finalRef: finalRef,
      postRef: postRef,
      handleToPost: handleToPost,
      getOrigin: getOrigin,
      formatName: formatName
    };
  }
});